// src/packages/chubb/pa/chubb_pa_series_e_2025/index.js
import ChubbPASeriesECard from "./ChubbPASeriesECard";
import ChubbPASeriesEDetails from "./ChubbPASeriesEDetails";
import "./chubb_pa_series_e.css";

/** Chubb — PA Series E (Plans 1–8 + Kid), Effective 2025 */
export default {
  id: "chubb_pa_series_e_2025",
  company: "ชับบ์ (Chubb)",              // ให้ตรงกับ COMPANY_INFO
  productLine: "non-motor",
  categories: ["personal accident", "PA", "health"],
  nameTH: "Chubb PA Series E — แผน 1–8 + Kid",
  description: "PA ชุด Series E: คุ้มครองชีวิต/ทุพพลภาพ/ค่ารักษา + แพ็กครอบครัว (เดี่ยว/คู่สมรส/ลูก)",
  accent: "#ef4444",                      // โทนแดงตามใบปลิว
  expiresAt: "9999-12-31",
  card: ChubbPASeriesECard,
  detail: ChubbPASeriesEDetails,
  active: true,
};
